import { createReducer, on } from "@ngrx/store";
import * as Actions from "./purchase-return.actions";
import { initialPurchaseReturnState } from "./purchase-return.state";

export const purchaseReturnReducer = createReducer(
  initialPurchaseReturnState,

  on(Actions.loadPurchaseByTransactionNo, (state) => ({
    ...state,
    loadingPurchase: true,
    error: null,
  })),
  on(Actions.loadPurchaseByTransactionNoSuccess, (state, { purchase }) => ({
    ...state,
    loadingPurchase: false,
    purchase,
  })),
  on(Actions.loadPurchaseByTransactionNoFailure, (state, { error }) => ({
    ...state,
    loadingPurchase: false,
    error,
  })),

  on(Actions.loadSupplierPurchases, (state) => ({
    ...state,
    loadingSupplierPurchases: true,
    error: null,
  })),
  on(Actions.loadSupplierPurchasesSuccess, (state, { data, total, page }) => ({
    ...state,
    loadingSupplierPurchases: false,
    supplierPurchases:
      page === 1 ? data : [...state.supplierPurchases, ...data],
    supplierPurchasesTotal: total,
    supplierPurchasesPage: page,
  })),
  on(Actions.loadSupplierPurchasesFailure, (state, { error }) => ({
    ...state,
    loadingSupplierPurchases: false,
    error,
  }))
);
